// All page copy is word for word from the original site (pmskillsfoundation.com) - check with the client before rewording

export const WHO_ARE_WE = {
  title: "WHO ARE WE?",
  text: "PM Skillshouse Foundation Development was founded by Nanako Tshukudu, a young, black, South African woman, in 2020. Designed to empower black-owned small businesses with world-class business management skills, PM Skillshouse Foundation is focused on helping businesses to become more profitable and employ more people to boost the local economy. PM Skillshouse Foundation Enterprise Development is about empowering, enhancing and building small businesses who are future-facing. In addition, PM Skillshouse Foundation assists businesses with access to start-up funding. Contact us today to find out more about our offerings!",
};

export const TESTIMONIAL = "\"We are so grateful for the PM Skillshouse Foundation team. They really created a huge impact in our business and in our lives. Portia and Nanako have cemented a new sense of direction for us – and have helped us achieve our goals. They really do care about small businesses and the community. Thank you!\"";

// "id" is also the #hash the home page tiles link to on the services page
export const SERVICES = [
  {
    id: "mentorship",
    title: "Mentorship",
    tagline: "Learn, Nurture, Thrive",
    text: "Business mentorship is one of the most proven ways to increase the chances of success for small businesses and entrepreneurs. A business mentor can truly share wisdom with you on an ongoing basis, and in a manner that can have a direct, positive impact on the growth of your business over time. The generic business advice you'll get from online publications will only go so far, and a good business mentor picks up right where that leaves off.",
  },
  {
    id: "business-management",
    title: "Business Management",
    tagline: "Finances, Operations, Markets",
    text: "As a business manager, you are given the major responsibility of managing administrative tasks for a business. As a new business, you will have to learn about marketing and sales. You will need to learn to perform a budget analysis in order to find out ways that the company can cut costs. You should have an astute understanding of accounting, marketing and administrative procedures that are required in order to run a business.",
  },
  {
    id: "funding-assistance",
    title: "Funding Assistance",
    tagline: "Investors, Funding, Networking",
    text: "Finding funding channels can be an incredibly difficult task. In our current global economic crisis, even more so. Having access to private and government investors, angel investors, funding schemes, start-up competitions and networks is more important than ever. But where do you start? Our team of experts have years’ worth of experience and contacts in all industries to point you in the right direction, and help you refine your pitch to increase your chances of securing that much needed funding.",
  },
  {
    id: "community-interaction",
    title: "Community Interaction",
    tagline: "Engage, Add value, Give back",
    text: "At PM Skillshouse Foundation, we believe that empowering our communities through skills development is paramount to sowing a sustainable future. Every action we take has a reverberating impact on the world around us. By engaging with the local community, helping with food and water distribution, basic education and quality-of-life improvements, all businesses should strive to contribute in a positive way. We seek to actively live out this conviction in everything we do.",
  },
];

export const NON_PROFIT = "PM Skillshouse Foundation is a non-profit company that aims to provide assistance to small businesses through its recently established Enterprise Development (ED) Program. Its parent company is PM Skillshouse (Pty) Ltd.";

export const ED_PROGRAM = [
  {
    title: "Objectives of the PM Skillshouse Foundation Enterprise Development Programme:",
    image: "/images/objectives.jpg",
    imageAlt: "Two colleagues working together at a laptop",
    points: [
      "To contribute towards the National Development Plan objective of reducing national unemployment rate.",
      "Provide an Enterprise Development Programme through structured programmes of mentoring and incubations.",
      "To enhance the competitiveness and supply capacity of participating enterprises by providing them with training, technical assistance, mentorship and other interventions which will enhance their capacity to access markets.",
    ],
  },
  {
    title: "How the ED program will work?",
    image: "/images/ed_program.jpg",
    imageAlt: "A businessman reading a business newspaper",
    intro: "The PM Skillshouse Foundation ED Program is a 24-month mentoring and coaching Program that will provide assistance to your business to help take it to the next level. Each business will get a tailored mentoring program based on the gaps and the needs of the business. The following will form part of the program:",
    points: [
      "One-on-one mentoring.",
      "Group based bootcamps where experts will address the group on topics common to all business e.g. financial management.",
      "Courses targeted at addressing challenges identified in each business.",
    ],
  },
  {
    title: "Commitment that will be required from the participants.",
    image: "/images/commitment.jpg",
    imageAlt: "A smiling businesswoman on the phone at her laptop",
    points: [
      "An average of 2 hours a week for mentorship/ bootcamps/ courses that we will be designed for your business.",
      "Access to virtual meetings – if this is a challenge – let us know.",
      "Each participant will be required to share some of the successes in their businesses and how they managed to get over challenges they were facing. A big part of the ED program is for group sharing and learnings so that each business owner has platform where they can share their challenges or bounce off ideas they have.",
    ],
  },
];

export const TEAM = [
  {
    name: "Portia Malatji",
    role: "PARTNER",
    image: "/images/portia.jpg",
    width: 784,
    height: 1024,
    bio: [
      "Portia first arrived in Johannesburg in 1996. Stepping out of the taxi with a suitcase and just R30, she began her life-long entrepreneurial journey. Soon after starting her formal career in administration, she discovered her love for training. Addressing the issue of over-indebtedness and unemployment by making information simple, easy-to-understand and practical, she was able to connect with schools, colleges, employees and communities around the country.",
      "Today, she continues working on making her dream a reality. Inspired by her vision to train 1 000 000 individuals in financial education, Portia seeks to change the world through skills development. For her, it is all about empowering communities!",
      "Portia is the founder and CEO of the renowned PM Skillshouse Training company – one of the most successfully informal financial training companies in South Africa.",
    ],
  },
  {
    name: "Nanako Tshukudu",
    role: "PARTNER",
    image: "/images/nanako.jpg",
    width: 639,
    height: 1024,
    bio: [
      "Nanako is a young, up-and-coming South African woman who’s driving passion is to see young businesses grow, thrive and prosper in the 21st century economy. Her young, dynamic, go-get attitude is contagious – and she quickly becomes a trusted friend to all around her. Starting her first company, PM Skillshouse Foundation, in 2020, she is ambitious and goal-oriented.",
      "She is driven by a desire to give back to the community around her – imparting the skills and knowledge she gained over her life so far to leave a mark on the world.",
    ],
  },
];

export const GALLERY = {
  backToSchool: {
    title: "Snapshots & Images",
    subtitle: "Back To School Project 2022",
    image: "/images/back_to_school_2022.jpg",
    imageAlt: "Youth In Action Special Thanks to PM Skills House - Back To School Project 2022",
  },
  community: {
    title: "Snapshots & Images",
    subtitle: "Community Interaction & Training",
    // [file, width, height]
    images: [
      ["community_01.jpg", 1050, 1400],
      ["community_02.jpg", 1000, 750],
      ["community_03.jpg", 768, 1024],
      ["community_04.jpg", 1400, 1050],
      ["community_05.jpg", 1400, 1400],
      ["community_06.jpg", 1280, 960],
      ["community_07.jpg", 1024, 768],
      ["community_08.jpg", 1000, 750],
      ["community_09.jpg", 768, 1024],
      ["community_10.jpg", 1040, 780],
      ["community_11.jpg", 1050, 1400],
      ["community_12.jpg", 774, 1032],
      ["community_13.jpg", 1400, 1050],
      ["community_14.jpg", 1156, 867],
      ["community_15.jpg", 768, 1024],
      ["community_16.jpg", 768, 1024],
    ],
  },
};

export const CONTACT = {
  homeTitle: "CONTACT US.",
  pageTitle: "TRUST US TO EMPOWER YOUR BUSINESS.",
};
